import React from 'react';
import { Card } from '../../components/ui/card';
import { ArrowDownCircle } from 'lucide-react';

const DepositFiat = () => {
  return (
    <div className="space-y-8 animate-fadeIn">
      <div>
        <h1 className="text-4xl font-bold text-black mb-2">Deposit Fiat</h1>
        <p className="text-gray-600">Deposit fiat currency via bank transfer</p>
      </div>

      <Card className="p-6 max-w-2xl">
        <h2 className="text-xl font-bold text-black mb-4 flex items-center">
          <ArrowDownCircle className="w-5 h-5 mr-2 text-[#0F4C5C]" />
          Bank Transfer Instructions
        </h2>
        <div className="space-y-4 text-black">
          <p>To deposit fiat currency, please transfer funds to:</p>
          <div className="bg-gray-50 p-4 rounded-lg space-y-2">
            <p><strong>Bank Name:</strong> Your Bank Name</p>
            <p><strong>Account Name:</strong> Aqua blockchain</p>
            <p><strong>Account Number:</strong> 1234567890</p>
            <p><strong>Routing Number:</strong> 123456789</p>
            <p><strong>Reference:</strong> Your User ID</p>
          </div>
          <p className="text-sm text-gray-600">Please include your user ID in the transfer reference for faster processing.</p>
        </div>
      </Card>
    </div>
  );
};

export default DepositFiat;
